import axios from "axios";

// Helpers interni — trovano settimana/arrivo nella mappa per anno
// e restituiscono strutture immutabili per garantire la reattività Vue 2.

function _mapSettimane(calendari, anno, id_settimana, fnSettimana) {
  const cal = calendari[anno];
  if (!cal) return calendari;
  return {
    ...calendari,
    [anno]: {
      ...cal,
      settimane: cal.settimane.map((s) =>
        s.id == id_settimana ? fnSettimana(s) : s
      ),
    },
  };
}

function _mapArrivi(settimana, id_arrivo, fnArrivo) {
  return {
    ...settimana,
    arrivi: settimana.arrivi.map((a) =>
      a.id == id_arrivo ? fnArrivo(a) : a
    ),
  };
}

export default {
  state: {
    // mappa { [anno]: { anno_rif, settimane: [...] } }
    // supporta più anni in cache simultaneamente
    calendari: {},
  },

  getters: {
    // get_calendario_arrivi(anno) → { anno_rif, settimane } | null
    get_calendario_arrivi: (state) => (anno) => {
      return state.calendari[anno] || null;
    },
    // get_lista_prodotti_arrivo({ anno, id_settimana, id_arrivo }) → prodotti[]
    get_lista_prodotti_arrivo: (state) => (payload) => {
      const cal = state.calendari[payload.anno];
      if (!cal) return [];
      const sett = cal.settimane.find((s) => s.id == payload.id_settimana);
      if (!sett) return [];
      const arrivo = sett.arrivi.find((a) => a.id == payload.id_arrivo);
      return arrivo ? arrivo.prodotti : [];
    },
  },

  mutations: {
    set_calendario_arrivi(state, { anno, data }) {
      state.calendari = { ...state.calendari, [anno]: data };
    },

    set_nuovo_arrivo(state, { anno, id_settimana, arrivo }) {
      state.calendari = _mapSettimane(
        state.calendari, anno, id_settimana,
        (s) => ({ ...s, arrivi: [...s.arrivi, arrivo] })
      );
    },

    delete_arrivo(state, { anno, id_settimana, id_arrivo }) {
      state.calendari = _mapSettimane(
        state.calendari, anno, id_settimana,
        (s) => ({ ...s, arrivi: s.arrivi.filter((a) => a.id != id_arrivo) })
      );
    },

    add_articolo_arrivo(state, { anno, id_settimana, id_arrivo, prodotto }) {
      state.calendari = _mapSettimane(
        state.calendari, anno, id_settimana,
        (s) => _mapArrivi(s, id_arrivo,
          (a) => ({ ...a, prodotti: [...a.prodotti, prodotto] })
        )
      );
    },

    set_nome_pdf_arrivo(state, { anno, id_settimana, id_arrivo, file_name }) {
      state.calendari = _mapSettimane(
        state.calendari, anno, id_settimana,
        (s) => _mapArrivi(s, id_arrivo, (a) => ({ ...a, pdf: file_name }))
      );
    },

    delete_articolo_arrivo(state, { anno, id_settimana, id_arrivo, id_prodotto }) {
      state.calendari = _mapSettimane(
        state.calendari, anno, id_settimana,
        (s) => _mapArrivi(s, id_arrivo,
          (a) => ({ ...a, prodotti: a.prodotti.filter((p) => p.id != id_prodotto) })
        )
      );
    },

    update_articolo_arrivo(state, { anno, id_settimana, id_arrivo, id_prodotto, qta }) {
      state.calendari = _mapSettimane(
        state.calendari, anno, id_settimana,
        (s) => _mapArrivi(s, id_arrivo,
          (a) => ({
            ...a,
            prodotti: a.prodotti.map((p) =>
              p.id == id_prodotto ? { ...p, qta } : p
            ),
          })
        )
      );
    },

    remove_pdf_arrivo(state, { anno, id_settimana, id_arrivo }) {
      state.calendari = _mapSettimane(
        state.calendari, anno, id_settimana,
        (s) => _mapArrivi(s, id_arrivo, (a) => ({ ...a, pdf: null }))
      );
    },
  },

  actions: {
    fetch_calendario_arrivi(context, anno) {
      return new Promise((resolve, reject) => {
        const auth = context.getters.get_credential;
        const url = process.env.VUE_APP_API_ROOT + "/admin/calendario_arrivi/" + anno;
        axios
          .get(url, { auth })
          .then((res) => {
            context.commit("set_calendario_arrivi", { anno, data: res.data });
            resolve(res.data);
          })
          .catch(reject);
      });
    },

    aggiungi_arrivo_settimana(context, { anno, id_settimana, id_fornitore }) {
      return new Promise((resolve, reject) => {
        const auth = context.getters.get_credential;
        const url =
          process.env.VUE_APP_API_ROOT +
          "/admin/calendario_arrivi/settimana/" +
          id_settimana +
          "/arrivo/fornitore/" +
          id_fornitore;
        axios
          .post(url, {}, { auth })
          .then((res) => {
            context.commit("set_nuovo_arrivo", { anno, id_settimana, arrivo: res.data });
            resolve(res.data);
          })
          .catch(reject);
      });
    },

    rimuovi_arrivo_settimana(context, { anno, id_settimana, id_arrivo }) {
      return new Promise((resolve, reject) => {
        const auth = context.getters.get_credential;
        const url =
          process.env.VUE_APP_API_ROOT + "/admin/calendario_arrivi/arrivo/" + id_arrivo;
        axios
          .delete(url, { auth })
          .then(() => {
            context.commit("delete_arrivo", { anno, id_settimana, id_arrivo });
            resolve();
          })
          .catch(reject);
      });
    },

    aggiungi_prodotto_arrivo(context, { anno, id_settimana, id_arrivo, id_specie, qta }) {
      return new Promise((resolve, reject) => {
        const auth = context.getters.get_credential;
        const url =
          process.env.VUE_APP_API_ROOT +
          "/admin/calendario_arrivi/arrivo/" +
          id_arrivo +
          "/articolo";
        axios
          .post(url, { id_arrivo, id_specie, qta }, { auth })
          .then((res) => {
            context.commit("add_articolo_arrivo", {
              anno, id_settimana, id_arrivo, prodotto: res.data,
            });
            resolve(res.data);
          })
          .catch(reject);
      });
    },

    rimuovi_prodotto_arrivo(context, { anno, id_settimana, id_arrivo, id_prodotto }) {
      return new Promise((resolve, reject) => {
        const auth = context.getters.get_credential;
        const url =
          process.env.VUE_APP_API_ROOT +
          "/admin/calendario_arrivi/prodotto/" +
          id_prodotto;
        axios
          .delete(url, { auth })
          .then(() => {
            context.commit("delete_articolo_arrivo", {
              anno, id_settimana, id_arrivo, id_prodotto,
            });
            resolve();
          })
          .catch(reject);
      });
    },

    modifica_prodotto_arrivo(context, { anno, id_settimana, id_arrivo, id_prodotto, qta }) {
      return new Promise((resolve, reject) => {
        const auth = context.getters.get_credential;
        const url =
          process.env.VUE_APP_API_ROOT +
          "/admin/calendario_arrivi/prodotto/" +
          id_prodotto +
          "/qta/" +
          qta;
        axios
          .put(url, {}, { auth })
          .then(() => {
            context.commit("update_articolo_arrivo", {
              anno, id_settimana, id_arrivo, id_prodotto, qta,
            });
            resolve();
          })
          .catch(reject);
      });
    },

    elimina_pdf_arrivo(context, { anno, id_settimana, id_arrivo }) {
      return new Promise((resolve, reject) => {
        const auth = context.getters.get_credential;
        const url =
          process.env.VUE_APP_API_ROOT +
          "/admin/calendario_arrivi/arrivo/" +
          id_arrivo +
          "/pdf";
        axios
          .delete(url, { auth })
          .then(() => {
            context.commit("remove_pdf_arrivo", { anno, id_settimana, id_arrivo });
            resolve();
          })
          .catch(reject);
      });
    },
  },
};
